
import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataTreaterRmtSummary extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name:CurrentLang().analytics_time_period, value: StringUtils.formatStringOrNoData(data.DateRange === undefined ? '' : CurrentLang()[`filter_option_${data.DateRange.toLowerCase()}`], CurrentLang().no_data) },
            { name:CurrentLang().analytics_number_of_organisations, value: StringUtils.formatStringOrNoData(data.OrganisationCount, CurrentLang().no_data) },
            { name:CurrentLang().analytics_number_of_clinics, value: StringUtils.formatStringOrNoData(data.ClinicCount, CurrentLang().no_data) },
            { name:CurrentLang().analytics_number_of_treaters, value: StringUtils.formatStringOrNoData(data.TreaterCount, CurrentLang().no_data) },
            { name:CurrentLang().analytics_number_of_patients, value: StringUtils.formatStringOrNoData(data.PatientCount, CurrentLang().no_data) },
            { name:CurrentLang().analytics_number_of_rmts, value: StringUtils.formatStringOrNoData(data.MotorThresholds, CurrentLang().no_data) },
            { name:CurrentLang().analytics_average_rmt, value: StringUtils.formatPercentOrNoDataWithDecimalPlaces(data.AverageMTLevel, CurrentLang().no_data, 1) },
        ];

        return tableData;
    }
}


export default MagstimTableDataTreaterRmtSummary;